import { ErrorHandler, Injectable, InjectionToken, Injector } from '@angular/core';
import * as Rollbar from 'rollbar';

import { environment, rollbarToken } from '../../../../environments/environment';

const rollbarConfig = {
  enabled: environment.rollbar.active,
  accessToken: rollbarToken,
  captureUncaught: true,
  captureUnhandledRejections: true,
  captureIP: 'anonymize',
  verbose: true,
  payload: {
    environment: environment.name,
    client: {
      javascript: {
        code_version: environment.rollbar.buildVersion
      }
    }
  }
};

@Injectable({
  providedIn: 'root'
})
export class RollbarErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(err: any): void {
    const rollbar = this.injector.get(RollbarService);
    if (environment.rollbar.active) rollbar.error(err?.originalError || err);
    else console.error(err?.originalError || err);
  }
}

export function rollbarFactory() {
  return new Rollbar(rollbarConfig);
}

export const RollbarService = new InjectionToken<Rollbar>('rollbar');
